import { axiosRequest } from "../../configs/axios.config";

export class OptionalService {
  fetchAll(success, error) {
    axiosRequest
      .get("/optionals")
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }

  availableElements(params, success, error) {
    axiosRequest
      .put("/optionals/activate", { optionals: params })
      .then(({ data }) => success(data))
      .catch((err) => error(err));
  }
}
